module.exports = __webpack_public_path__ + "static/media/mdwa.6f1ed0c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/mdwa.svg?62057485
// module id = 47
// module chunks = 0